import React from "react";
import Button from "../elements/Button";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Footer Component
export default function Footer() {
  const position = [9.03, 38.74]; // Coordinates for Addis Ababa

  return (
    <div className="bg-gray-50 border-t border-gray-200 pb-6">
      <div className="container flex-col mx-auto">
        <div className="flex flex-col sm:flex-row mt-8 justify-center">
          {/* Map Section */}
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <MapContainer
              center={position}
              zoom={13}
              style={{ height: "250px", width: "100%" }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={position}>
                <Popup>Addis Ababa</Popup>
              </Marker>
            </MapContainer>
          </div>

          {/* Contact Info Section */}
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Address</h1>
            <p className="text-lg text-gray-400 font-light">Subcity : Bole</p>
            <p className="text-lg text-gray-400 font-light">Woreda : 05</p>
            <p className="text-lg text-gray-400 font-light">House No : 999/1</p>
            <p className="text-lg text-gray-400 font-light">Office No : 301</p>
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Phone</h1>
            <p className="text-lg text-gray-400 font-light">
              Telephone : 251-116673422
            </p>
            <p className="text-lg text-gray-400 font-light">
              Mobile : 251-0911122630
            </p>
            <p className="text-lg text-gray-400 font-light">
              Fax : 251-116672366
            </p>
          </div>
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Email</h1>
            <p className="text-lg text-gray-400 font-light">
              info@atlandscapet.com
            </p>
            <h1 className="text-lg text-theme-blue pt-4 pb-2">P.O.Box</h1>
            <p className="text-lg text-gray-400 font-light">13734</p>
            <h1 className="text-lg text-theme-blue pt-4 pb-2">TIN</h1>
            <p className="text-lg text-gray-400 font-light">0044986273</p>
          </div>

          {/* Social Links Section */}
          <div className="w-1/3 ml-16 sm:ml-0 mt-0">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Social</h1>
            <Button
              href="/"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-400 font-light hover:underline"
              isExternal
            >
              Facebook
            </Button>
            <Button
              href="/"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-400 font-light hover:underline"
              isExternal
            >
              LinkedIn
            </Button>
            <Button
              href="/"
              type="link"
              target="_blank"
              className="flex text-lg text-gray-400 font-light hover:underline"
              isExternal
            >
              Twitter
            </Button>
          </div>
        </div>

        {/* Footer Copyright */}
        <div className="flex-col text-center mt-7">
          <p className="text-lg text-gray-400 font-light">
            Copyright 2025 - All rights reserved - Yod Business Solution
          </p>
        </div>
      </div>
    </div>
  );
}
